import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import SearchBar from "../../components/SearchBar";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, IconButton, Button } from "@mui/material";
import AddNotification from "../../Modals/addNotification";
import AddIcon from '@mui/icons-material/Add';
import NotificationsList from "../../features/manageNotifications/notificationsList";
import { useDeleteNotificationMutation, useLazyGetNotificationQuery } from "../../services/notification";
import { showError, showToast } from "../../constants/toasts";
import toast from "react-hot-toast";
import { isValidInput } from "../../utils/validations";

const ManageNotifications = () => {

    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [getNotifacation] = useLazyGetNotificationQuery()
    const [rows, setRows] = useState<any[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [deleteNotification] = useDeleteNotificationMutation()
    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    const [loading, setLoading] = useState(false);
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
    const [page, setPage] = useState<number>(1);

    const getNotifiationApi = async () => {
        setLoading(true);
        try {
            const response = await getNotifacation({
                from: page,
                search: debouncedSearchTerm,
                size: 10,
            } as any).unwrap();
            setLoading(false);
            if (response.statusCode === 200) {
                setRows(response?.data?.data || []);
                setTotal(response?.data?.total || 0);
            }
        } catch (error: any) {
            setLoading(false);
            showError(error?.data?.message || "");
        } finally {
        }
    };
    const deleteNotificationApi = async (id: string) => {
        setLoading(true);
        try {
            const response = await deleteNotification({
                id,
            }).unwrap();
            setLoading(false);
            if (response?.statusCode === 200) {
                toast.dismiss()
                showToast(response?.message);
                getNotifiationApi();
            }
        } catch (error: any) {
            showError(error?.data?.message || "");
            setLoading(false);
        }
    };
    useEffect(() => {
        getNotifiationApi()
    }, [page, searchTerm, debouncedSearchTerm])

    return (
        <MainContainer>
            <div className="main_title">
                <h1>Manage Notifications</h1>
                <p>
                    <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
                    Manage Notifications
                </p>
            </div>

            <div className="cards">
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            placeholder="Search..."
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setDebouncedSearchTerm}
                            value={searchTerm}
                            onCross={() => setSearchTerm("")}
                            onChange={(val: any) => {
                                if (isValidInput(val.target.value)) {
                                    setSearchTerm(val.target.value);
                                }
                            }}
                        />
                    </div>
                    <div className="right_s">
                        <Button className="btn btn_primary" onClick={() => setOpenModal(true)}><AddIcon /> Add Notification</Button>
                    </div>
                </div>

                <NotificationsList
                    rows={rows}
                    count={total}
                    page={page}
                    onPageChange={(e: any, p: number) => setPage(p)}
                    loading={loading}
                    deleteNotificationApi={deleteNotificationApi}
                />
            </div>

            <AddNotification open={openModal} onClose={handleCloseModal} setOpen={setOpenModal} getNotifiationApi={getNotifiationApi} />
        </MainContainer>
    );
};

export default ManageNotifications;
